import React from 'react'
import { withRouter } from 'react-router'

import { useUnit } from 'effector-react'

import { useCallback, useEffect, useMediaQueries, useRef } from 'hooks'

import { urlTo } from 'helpers/router.js'

import { $activeTransferRequestsLoading } from 'app/effector/nominees-transfers/request/sipp'

import GlobalPreloader from 'components/_old/GlobalPreloader/GlobalPreloader.jsx'
import { Typo } from 'components/_old/Typo/Typo'

import { DesktopLayout, MobileLayout, MobileLayoutFooterButton } from 'components/atoms/Layouts'

import { AnimatedNavigationBar } from 'components/molecules/AnimatedNavigationBar'

import { DesktopFooter } from 'app/containers/Footer'
import { DesktopHeader } from 'app/containers/Header'

import { Content, StartANewTransferLink } from './components'
import { setPrevPage, goBack, initTransferCentre } from './model'

type TransferCentreProps = {
  location: {
    query: {
      prev?: string
      next?: string
    }
  }
}

const TransferCentre = withRouter(({ location }: TransferCentreProps): React.ReactElement => {
  const { desktop } = useMediaQueries()
  const titleRef = useRef<HTMLElement>()
  const [activeTransferRequestsLoading] = useUnit([$activeTransferRequestsLoading])

  const handleMount = useCallback(() => {
    const defaultUrl = urlTo('dashboard')

    const prevUrl = location.query.prev ?? defaultUrl

    setPrevPage(prevUrl)

    initTransferCentre()
  }, [location?.query])

  useEffect(() => {
    handleMount()
  }, [handleMount])

  if (activeTransferRequestsLoading) {
    return <GlobalPreloader loading />
  }

  const desktopLayout = <DesktopLayout header={<DesktopHeader />} content={<Content />} footer={<DesktopFooter />} />

  const mobileLayout = (
    <MobileLayout
      header={
        <AnimatedNavigationBar nodeToWatchTo={titleRef?.current} leftPartText="Back" onLeftPartClick={goBack}>
          <Typo>Transfer center</Typo>
        </AnimatedNavigationBar>
      }
      content={<Content />}
      footer={
        <MobileLayoutFooterButton>
          <StartANewTransferLink />
        </MobileLayoutFooterButton>
      }
    />
  )

  return <React.Fragment>{desktop ? desktopLayout : mobileLayout}</React.Fragment>
})
TransferCentre.displayName = 'TransferCentre'

export { TransferCentre }
